export function clampDimension(windowDimension, dimension) {
    if (dimension < windowDimension * 0.2) {
        return windowDimension * 0.2 - 36;
    }
    if (dimension > windowDimension * 0.8) {
        return windowDimension * 0.8 - 36;
    }
    return dimension;
}
//# sourceMappingURL=clampDimension.js.map